<template>
    <common-dropdown :isOpen="true" :hasArrow="false" arrowPositionY="bottom" arrowPositionX="right">
        <common-progress :percentage="profilePercentage" :isBarHidden="false" :isRounded="false"></common-progress>
        <common-content-spacer class="select-tests-reminder__spacer" height="micro">
            <p class="complete-profile-reminder__rating-percentage">
                {{ $t('elements.home.profile_reminder.percentage', { profilePercentage }) }}
            </p>
            <div>
                <div class="select-tests-reminder__circle"></div>
                <b class="select-tests-reminder__text-bold">
                    {{ $t('elements.home.select_tests_reminder.header') }}
                </b>
            </div>
            <div class="select-tests-reminder__text">
                <p class="select-tests-reminder__link" @click="goToTestSelection()">
                    {{ $t('elements.home.select_tests_reminder.practice_profile') }}
                </p>
                <p>{{ $t('elements.home.select_tests_reminder.select_tests') }}</p>
            </div>
        </common-content-spacer>
    </common-dropdown>
</template>
<script>
    export default {
        data() {
            return {
                profilePercentage: 80,
            }
        },

        methods: {
            goToTestSelection() {
                const facilityServices = this.$auth.getFacilityServicesByLocation()
                const locationsLength = this.$auth.getPractice().locations.length + 1
                if (facilityServices.length) {
                    const firstServiceWithoutTests = facilityServices.find(
                        (service) => service.practiceTypesSubgroups.length !== locationsLength,
                    )
                    if (firstServiceWithoutTests?.facilityServiceTypeId) {
                        this.$router.push(
                            `/practice/service/${firstServiceWithoutTests.facilityServiceTypeId}/tests?advance=true`,
                        )
                    }
                }
            },
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/components/profile/_select-tests-reminder.scss';
</style>
